import { connect } from 'react-redux';
import ScheduleTable from '../components/ScheduleTable';
import { FETCH_SCHEDULE, TOGGLE_SCHEDULE_DAY_CARD } from '../actions/schedule-slider';


const mapStateToProps = state => ({
    days: state.schedule.days,
    events: state.schedule.events,
    sports: state.schedule.sports
});

const mapDispatchToProps = (dispatch) => {
    dispatch(FETCH_SCHEDULE());
    return {
        toggleEventCard: (sportName, date) => {
            dispatch(TOGGLE_SCHEDULE_DAY_CARD(sportName, date));
        }
    };
};

const ScheduleTableContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(ScheduleTable);

export default ScheduleTableContainer;



// WEBPACK FOOTER //
// ./src/containers/ScheduleTable.container.js